<template>
  <div class="inbox--name">
    <div class="inbox--icon">
      <fluent-icon
        v-if="
          computedInboxClass !== 'brand-conversa' &&
            computedInboxClass !== 'brand-evolution-api'
        "
        :icon="computedInboxClass"
        size="12"
      />
      <svg
        v-if="computedInboxClass === 'brand-evolution-api'"
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.6689 2.32517C12.1648 0.826576 10.1645 0.0008441 8.03338 0C3.64233 0 0.0685607 3.55645 0.0667971 7.92789C0.0662205 9.32523 0.433053 10.6892 1.13021 11.8915L0 16L4.22319 14.8975C5.3868 15.5291 6.69686 15.862 8.03021 15.8625H8.0335C12.4241 15.8625 15.9982 12.3057 16 7.93418C16.0008 5.81573 15.173 3.82374 13.6689 2.32514V2.32516V2.32517ZM8.03348 14.5235H8.03077C6.84262 14.5231 5.67727 14.2054 4.66061 13.605L4.41881 13.4622L1.91271 14.1165L2.58163 11.6847L2.42416 11.4354C1.76135 10.3862 1.41127 9.17353 1.41179 7.92841C1.41323 4.29507 4.38364 1.33905 8.03604 1.33905C9.8046 1.33972 11.4671 2.02609 12.7173 3.27166C13.9675 4.51722 14.6555 6.1729 14.6549 7.93369C14.6535 11.5673 11.6831 14.5235 8.03348 14.5235Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.36273 11.7683C5.41879 11.802 5.53397 11.802 5.79814 11.8017C6.91916 11.8008 7.88749 11.7973 8.57623 11.7973C11.7906 11.7973 11.7061 8.42862 10.2032 8.00833C10.4233 7.62008 11.4262 6.89079 10.806 5.38333C10.1926 3.89272 7.55482 4.23098 5.75078 4.23186C5.08326 4.23195 5.18308 4.72298 5.1865 5.48643C5.19198 6.69567 5.18749 9.96885 5.18667 11.3838C5.1865 11.6706 5.27345 11.7147 5.36273 11.7683ZM6.75353 10.5338C7.05704 10.5338 7.77295 10.5338 8.38659 10.5328C9.08152 10.5318 9.70035 10.2082 9.68488 9.51945C9.67352 8.87068 9.23996 8.65776 8.63821 8.59832C8.06503 8.60379 7.40944 8.60379 6.75351 8.60379V10.5338H6.75353ZM6.75353 7.30082C7.96259 7.28433 8.42902 7.34934 9.08914 7.18474C9.54269 6.92844 9.74084 5.97785 9.09168 5.65498C8.6407 5.43067 7.30802 5.50741 6.75353 5.53041V7.30084V7.30082Z"
          fill="currentColor"
        />
      </svg>
      <svg
        v-if="computedInboxClass === 'brand-conversa'"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.44206 3.42186L0.306083 5.27597C-0.102028 5.62976 -0.102028 6.21257 0.306083 6.56636L0.604092 6.82474L1.36159 7.48241L3.26415 9.13394L3.21718 9.00769C2.87953 8.09605 3.1379 7.06256 3.86898 6.36231L5.18286 5.11008C5.51463 4.79446 5.51463 4.27184 5.18286 3.93713L4.78649 3.53636C4.16112 2.90511 3.11295 2.84052 2.44353 3.42186H2.44206Z"
          fill="currentColor"
        />
        <path
          d="M10.3925 8.03146L11.8135 6.41957C12.0616 6.13918 12.0616 5.68849 11.8135 5.4081L11.6286 5.19817L11.1412 4.64473L9.79647 3.11798L9.83171 3.23249C10.0827 4.04724 9.89189 4.92512 9.32817 5.52114L8.23156 6.67354C7.93649 6.98329 7.93649 7.47948 8.23156 7.77309L8.58095 8.11954C9.09623 8.63188 9.90804 8.58197 10.394 8.03146H10.3925Z"
          fill="currentColor"
        />
        <path
          d="M4.34014 10.0676L6.17958 11.6634C6.49814 11.9393 7.00607 11.8748 7.31289 11.5254L7.5375 11.2699L8.11003 10.6196L9.55897 8.97541L9.43712 9.02826C8.66934 9.35709 7.79147 9.21029 7.1749 8.62895L7.16168 8.61721L5.9535 7.46775C5.6276 7.15799 5.0903 7.1712 4.75119 7.50738L4.33867 7.91696C3.70742 8.54381 3.70742 9.52004 4.33867 10.0676H4.34014Z"
          fill="currentColor"
        />
        <path
          d="M8.9423 2.15054L7.31866 0.309637C7.01185 -0.0397526 6.50391 -0.104346 6.18535 0.171643L5.94753 0.378634L5.31921 0.92474L3.57227 2.44121L3.72934 2.40304C4.67328 2.17109 5.67448 2.47057 6.32922 3.15614L6.34243 3.17082L7.53153 4.42011C7.83247 4.73573 8.31105 4.74894 8.60172 4.45534L8.9423 4.11035C9.4517 3.59654 9.4517 2.72894 8.9423 2.15201V2.15054Z"
          fill="currentColor"
        />
      </svg>
    </div>
    <p class="text-truncate label">
      {{ inbox.name }}
    </p>
  </div>
</template>
<script>
import { getInboxClassByType } from 'dashboard/helper/inbox';

export default {
  props: {
    inbox: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    computedInboxClass() {
      const { phone_number: phoneNumber, channel_type: type } = this.inbox;
      const classByType = getInboxClassByType(type, phoneNumber);
      return classByType;
    },
  },
};
</script>
<style scoped>
.inbox--name {
  max-width: calc(100% / 3);
  display: flex;
  padding: var(--space-micro) 0;
  line-height: var(--space-normal);
  font-weight: var(--font-weight-normal);
  background: none;
  color: var(--conversa2-blue-600-color);
  font-size: var(--font-size-mini);
  height: 16px;
  align-items: center;
  gap: 4px;
}

.inbox--icon {
  margin-top: var(--space-smaller);
}

.label {
  line-height: var(--space-normal);
  font-weight: var(--font-weight-normal);
  background: none;
  font-size: var(--font-size-mini);
  padding: 0;
  margin: 0;
  color: var(--conversa2-blue-600-color);
}
</style>
